import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentLoadAuditsPage() {
  return <LatamAgentPage locale="en-LATAM" agentKey="proactive_load_audits" />;
}
